import React from "react";
import { Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../form/InputField";
import CustomSelect from "../../form/CustomSelect";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    code: Yup.string().required("Code is required").matches(/^[A-Z0-9_]+$/, "Code must be uppercase alphanumeric with underscores"),
    value_type: Yup.string().required("Value type is required"),
});

const FeatureModal = ({ onClose, selectedItem, onSubmit }) => {
    return (
        <Formik
            initialValues={{
                name: selectedItem?.name || "",
                code: selectedItem?.code || "",
                description: selectedItem?.description || "",
                value_type: selectedItem?.value_type || "boolean",
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue,
            }) => (
                <Form onSubmit={handleSubmit}>
                    <Modal.Body className="grid gap-3">
                        <InputField
                            className="g-col-6"
                            label={{ name: "Feature Name" }}
                            input={{
                                id: "name",
                                name: "name",
                                placeholder: "e.g. Max Listings",
                                value: values.name,
                                onChange: handleChange,
                            }}
                            validation={{
                                isInvalid: touched.name && errors.name,
                                message: errors.name,
                            }}
                        />
                        <InputField
                            className="g-col-6"
                            label={{ name: "Feature Code" }}
                            input={{
                                id: "code",
                                name: "code",
                                placeholder: "e.g. MAX_LISTINGS",
                                value: values.code,
                                onChange: (e) => setFieldValue("code", e.target.value.toUpperCase()),
                            }}
                            validation={{
                                isInvalid: touched.code && errors.code,
                                message: errors.code,
                            }}
                        />
                        <CustomSelect
                            label={{ name: "Value Type" }}
                            name="value_type"
                            options={[
                                { value: "boolean", label: "Boolean (Yes/No)" },
                                { value: "number", label: "Number" },
                                { value: "text", label: "Text" },
                                { value: "json", label: "JSON" },
                            ]}
                            value={values.value_type}
                            onChange={(opt) => setFieldValue("value_type", opt ? opt.value : "")}
                            className="g-col-12 shadow-none"
                        />
                        <InputField
                            className="g-col-12"
                            label={{ name: "Description" }}
                            input={{
                                as: "textarea",
                                rows: 3,
                                id: "description",
                                name: "description",
                                value: values.description,
                                onChange: handleChange,
                                placeholder: "Describe the feature's purpose",
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <CommonButton
                            title="Cancel"
                            variant="outline"
                            onClick={onClose}
                        />
                        <CommonButton
                            title={selectedItem ? "Update" : "Create"}
                            variant="primary"
                            type="submit"
                            disabled={isSubmitting}
                        />
                    </Modal.Footer>
                </Form>
            )}
        </Formik>

    );
};

export default withModal(FeatureModal);